import { CalendarYearPage } from "@/pages/mill/schedule/calendar-year/CalendarYearPage";
import { CalendarAreaProvider } from "@/pages/mill/schedule/calendar/context/CalendarAreaContext";
import { MILL_1, MILL_2 } from "@/setup/mill-config/mill-config";

export const routeCalendarYear = "/calendar-year";
export const routeCalendarYearM1 = "/calendar-year/m1";
export const routeCalendarYearM2 = "/calendar-year/m2";

const M1CalendarYear = () => (
	<CalendarAreaProvider areaId={MILL_1.id}>
		<CalendarYearPage />
	</CalendarAreaProvider>
);

const M2CalendarYear = () => (
	<CalendarAreaProvider areaId={MILL_2.id}>
		<CalendarYearPage />
	</CalendarAreaProvider>
);

export const calendarYearRoute = [
	{
		path: `${routeCalendarYear}`,
		element: <CalendarYearPage />,
	},
	{
		path: `${routeCalendarYear}/:year`,
		element: <CalendarYearPage />,
	},
	{
		path: `${routeCalendarYearM1}`,
		element: <M1CalendarYear />,
	},
	{
		path: `${routeCalendarYearM1}/:year`,
		element: <M1CalendarYear />,
	},
	{
		path: `${routeCalendarYearM2}`,
		element: <M2CalendarYear />,
	},
	{
		path: `${routeCalendarYearM2}/:year`,
		element: <M2CalendarYear />,
	},
];
